var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('div',{staticClass:"w-full h-screen"},[_c('Alerta',{attrs:{"mensagem-erro":_vm.mensagemDeErro,"mostra-alerta":_vm.mostrarAlerta},on:{"closeAlert":_vm.fecharAlerta}}),_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }